import { StoppableEventInterface } from '../../interfaces/components/event-manager/stoppable-event.interface';

export class Event implements StoppableEventInterface {
  private static emptyEventArgsInstance: Event;
  private propagationStopped = false;

  public static getEmptyInstance (): Event {
    if (!Event.emptyEventArgsInstance) {
      Event.emptyEventArgsInstance = new Event();
    }

    return Event.emptyEventArgsInstance;
  }

  public isPropagationStopped (): boolean {
    return this.propagationStopped;
  }

  public stopPropagation (): void {
    this.propagationStopped = true;
  }
}
